/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { GetLeadByExternalIdPhotosQueryResponse, GetLeadByExternalIdPhotosPathParams, GetLeadByExternalIdPhotos401, GetLeadByExternalIdPhotos403, GetLeadByExternalIdPhotos404, GetLeadByExternalIdPhotos503 } from "../models/GetLeadByExternalIdPhotos";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLeadByExternalIdPhotosQueryKey = ({ externalId }: { externalId: GetLeadByExternalIdPhotosPathParams["externalId"] }) => [{ url: '/api/v1/contact/leads/by-external-id/:externalId/photos', params: {externalId:externalId} }] as const

export type GetLeadByExternalIdPhotosQueryKey = ReturnType<typeof getLeadByExternalIdPhotosQueryKey>

/**
 * @description Returns all photos attached to the lead. Looks up by the Lease End external deal ID instead of UUID.
 * @summary List photos for a lead (driver view) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/photos}
 */
export async function getLeadByExternalIdPhotos({ externalId }: { externalId: GetLeadByExternalIdPhotosPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLeadByExternalIdPhotosQueryResponse, ResponseErrorConfig<GetLeadByExternalIdPhotos401 | GetLeadByExternalIdPhotos403 | GetLeadByExternalIdPhotos404 | GetLeadByExternalIdPhotos503>, unknown>({ method : "GET", url : `/api/v1/contact/leads/by-external-id/${externalId}/photos`, ... requestConfig })
  return res
}

export function getLeadByExternalIdPhotosQueryOptions({ externalId }: { externalId: GetLeadByExternalIdPhotosPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLeadByExternalIdPhotosQueryKey({ externalId })
        return queryOptions<ResponseConfig<GetLeadByExternalIdPhotosQueryResponse>, ResponseErrorConfig<GetLeadByExternalIdPhotos401 | GetLeadByExternalIdPhotos403 | GetLeadByExternalIdPhotos404 | GetLeadByExternalIdPhotos503>, ResponseConfig<GetLeadByExternalIdPhotosQueryResponse>, typeof queryKey>({
         enabled: !!(externalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLeadByExternalIdPhotos({ externalId: externalId }, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all photos attached to the lead. Looks up by the Lease End external deal ID instead of UUID.
 * @summary List photos for a lead (driver view) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/photos}
 */
export function useGetLeadByExternalIdPhotos<TData = ResponseConfig<GetLeadByExternalIdPhotosQueryResponse>, TQueryData = ResponseConfig<GetLeadByExternalIdPhotosQueryResponse>, TQueryKey extends QueryKey = GetLeadByExternalIdPhotosQueryKey>({ externalId }: { externalId: GetLeadByExternalIdPhotosPathParams["externalId"] }, options: 
{
  query?: Partial<QueryObserverOptions<ResponseConfig<GetLeadByExternalIdPhotosQueryResponse>, ResponseErrorConfig<GetLeadByExternalIdPhotos401 | GetLeadByExternalIdPhotos403 | GetLeadByExternalIdPhotos404 | GetLeadByExternalIdPhotos503>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLeadByExternalIdPhotosQueryKey({ externalId })
         

         const query = useQuery({
          ...getLeadByExternalIdPhotosQueryOptions({ externalId }, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLeadByExternalIdPhotos401 | GetLeadByExternalIdPhotos403 | GetLeadByExternalIdPhotos404 | GetLeadByExternalIdPhotos503>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}